import { serviceCategoriesEnum } from 'components/StrategiesList/SimulationDetailPopUp/DetailTable/helpers';
import {
  IServicesCategories,
  ISimulation,
  ISimulationMailingRule,
  ISimulationResponse,
} from 'components/StrategiesList/SimulationDetailPopUp/DetailTable/interfaces';

export const getSimulationChangeOnlyHeaders = (
  currentSimulation: ISimulation,
  simulationDistribution: ISimulationResponse,
): ISimulation => ({
  ...currentSimulation,
  countPreparingSimulation: simulationDistribution.countPreparingSimulation,
  countExecutedSimulation: simulationDistribution.countExecutedSimulation,
  countPreparingDistribution: simulationDistribution.countPreparingDistribution,
  countExecutedDistribution: simulationDistribution.countExecutedDistribution,
  status: simulationDistribution.status,
  createdAt: simulationDistribution.createdAt,
  updatedAt: simulationDistribution.updatedAt,
  startAtDistribution: simulationDistribution.startAtDistribution,
  startAtSimulation: simulationDistribution.startAtSimulation,
});

export const getParsedSimulation = (
  simulationResponse: ISimulationResponse,
): ISimulation => {
  const serviceCategoriesKeys = Object.keys(serviceCategoriesEnum);
  const simulationCopy = Object.assign({}, simulationResponse);
  const parsedSeviceCategories = serviceCategoriesKeys.reduce(
    (servicesCategories, key) => {
      if (simulationCopy[key]) {
        servicesCategories[key] = (simulationCopy[
          key
        ] as unknown) as ISimulationMailingRule;

        servicesCategories[key] = getSortedServicesCategories(
          servicesCategories[key],
        );

        delete simulationCopy[key];
      }
      return servicesCategories;
    },
    {} as IServicesCategories,
  );

  return {
    ...simulationCopy,
    serviceCategories: parsedSeviceCategories,
  };
};

const getSortedServicesCategories = (
  serviceCategory: ISimulationMailingRule,
) => {
  const sortedMailingIds = Object.keys(serviceCategory).sort(
    (first, second) =>
      serviceCategory[first].priority - serviceCategory[second].priority,
  );

  return sortedMailingIds.reduce((serviceCategoryByPriority, id) => {
    serviceCategoryByPriority[id] = serviceCategory[id];
    return serviceCategoryByPriority;
  }, {} as ISimulationMailingRule);
};
